export default "__VITE_ASSET__DmkDZw9o__"